import { SVGProps } from 'react';

const Tick = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='28'
      height='28'
      viewBox='0 0 28 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <circle cx='14' cy='14' r='14' fill={props?.fill || '#FF8890'} />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M21.9939 7.43558C22.3056 7.70834 22.3372 8.18216 22.0644 8.49389L11.5644 20.4939C11.4277 20.6501 11.2324 20.7427 11.025 20.7496C10.8175 20.7565 10.6164 20.6771 10.4697 20.5303L5.96967 16.0303C5.67678 15.7374 5.67678 15.2626 5.96967 14.9697C6.26256 14.6768 6.73744 14.6768 7.03033 14.9697L10.9635 18.9028L20.9356 7.50613C21.2083 7.1944 21.6822 7.16282 21.9939 7.43558Z'
        fill='white'
      />
    </svg>
  );
};
export const TickSM = () => {
  return (
    <svg
      style={{ width: 18, height: 18 }}
      width='28'
      height='28'
      viewBox='0 0 28 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='14' cy='14' r='14' fill='#FF8890' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M21.9939 7.43558C22.3056 7.70834 22.3372 8.18216 22.0644 8.49389L11.5644 20.4939C11.4277 20.6501 11.2324 20.7427 11.025 20.7496C10.8175 20.7565 10.6164 20.6771 10.4697 20.5303L5.96967 16.0303C5.67678 15.7374 5.67678 15.2626 5.96967 14.9697C6.26256 14.6768 6.73744 14.6768 7.03033 14.9697L10.9635 18.9028L20.9356 7.50613C21.2083 7.1944 21.6822 7.16282 21.9939 7.43558Z'
        fill='white'
      />
    </svg>
  );
};

export default Tick;

export const TickV2 = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='25' height='25' viewBox='0 0 16 15' fill='none'>
      <circle cx='7.5' cy='7.5' r='7.5' fill='#06AD00' />
      <path
        d='M6.36041 10.4968C6.20033 10.4968 6.04825 10.4299 5.9362 10.3127L3.67103 7.94363C3.43892 7.70087 3.43892 7.29906 3.67103 7.0563C3.90315 6.81353 4.28734 6.81353 4.51945 7.0563L6.36041 8.98165L10.4744 4.6789C10.7066 4.43614 11.0907 4.43614 11.3229 4.6789C11.555 4.92166 11.555 5.32347 11.3229 5.56624L6.78462 10.3127C6.67256 10.4299 6.52049 10.4968 6.36041 10.4968Z'
        fill='white'
      />
    </svg>
  );
};